import { useEffect, useState, type FC } from "react"

import { Header } from "@/components/common/header/Header"
import { BaseSettings } from "@/components/admin/settings/types"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { useStore } from "@/stores/RootStoreContext"
import { MenuManager } from "@/components/manager/MenuManager"

import { MenuClient } from "../MenuClient"
import { ClientRates } from "./Rates"

export const BaseClientRates: FC = () => {
  const { userStore } = useStore()

  const [baseSettings, setBaseSettings] = useState<BaseSettings>()

  useEffect(() => {
    TrinityAPI.getBaseSettings().then(response => setBaseSettings(response.data))
  }, [])

  return (
    <>
      {userStore.isClient ? <MenuClient active={"base-client-rates"} /> : <MenuManager active={"base-client-rates"} />}

      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Ставки платформы</h1>

          <div className="form-block-popup">
            <h4 className="heading-chapter">Ставки</h4>
            <div className="popup-group-container">
              <div className="popup-gruop-text">
                <div className="flex-row-justify">
                  <p className="popup-text">
                    <span className="popup-subline">Базовая ставка&nbsp;</span>
                    {baseSettings?.baseRate}%
                  </p>
                  <p className="popup-text">
                    <span className="popup-subline">Стоимость SWIFT&nbsp;</span>
                    {baseSettings?.swiftAmount} USD
                  </p>
                  <p className="popup-text">
                    <span className="popup-subline">Стоимость расследования&nbsp;</span>
                    {baseSettings?.inquiryAmount} USD
                  </p>
                </div>
              </div>

              <div className="flex-row-24 flex-mobile-column">
                <ClientRates rateType={"AMOUNT"} />
                <ClientRates rateType={"M_VAL"} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
